import { Component } from "react";

import AppErrorState from "@/components/ui/AppErrorState";
import { logAppError } from "@/lib/api";

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error, errorInfo) {
    logAppError("ui.error-boundary", error, {
      componentStack:
        typeof errorInfo?.componentStack === "string"
          ? errorInfo.componentStack.split("\n").slice(0, 4).join("\n")
          : undefined,
    });
  }

  handleRetry = () => {
    this.setState({
      hasError: false,
    });
  };

  render() {
    if (this.state.hasError) {
      return (
        <AppErrorState
          fullScreen
          title="Une erreur a interrompu l'affichage"
          message="Service indisponible, réessayez"
          onRetry={this.handleRetry}
          testId="global-error-boundary"
        />
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
